import React from 'react';
import { InsuranceDTO, InsuranceType } from '../../api/useInsuranceQuery';
import { InsuranceTable } from '../../components/InsuranceTable/InsuranceTable';
import { Text } from '../../../../CommonComponents/OPL/Text/Text';
import { formatCurrency } from '../../../../CommonUtils/formatNumber';
import { ColumnHeader } from '../../../OtherAssets/OtherAssets.meta';
import { TableActions } from '../../components/TableActions/TableActions';
import { InsuranceToDelete, InsuranceToUpsert } from '../../Insurance.meta';
import { WorkflowComponentProps } from '../../../../Workflow/Workflow.meta';
import { useIsPdf } from '../../../../FinancialPlanOPL/hooks/useIsPdf';

const columnHeaders: ColumnHeader[] = [
  { text: 'Name' },
  { text: 'Owner' },
  { text: 'Insured Members' },
  { text: 'Family Deductible', align: 'right' },
  { text: 'Out of Pocket Limit', align: 'right' },
  { text: 'Premium', align: 'right' },
];

interface Props {
  data: InsuranceDTO;
  setInsuranceToUpsert(insurance: InsuranceToUpsert): void;
  setInsuranceToDelete(insurance: InsuranceToDelete): void;
  workflowProps?: WorkflowComponentProps;
}

export const HealthInsurance = ({
  data,
  setInsuranceToUpsert,
  setInsuranceToDelete,
  workflowProps,
}: Props) => {
  const items = data.Items.HealthInsurance || [];

  const isPrint = useIsPdf();

  return (
    <InsuranceTable
      title="Health Insurance Policies"
      isEmpty={items.length === 0}
      columnHeaders={columnHeaders}
      onAddInsurance={() => setInsuranceToUpsert({ InsuranceType: InsuranceType.HealthInsurance })}
      workflowProps={workflowProps}
    >
      {items.map(insurance => (
        <tr key={insurance.AccountId}>
          <td>
            <Text fontWeight={500} textAlign="left" width="100%">
              {insurance.Description}
            </Text>
          </td>

          <td>
            <Text fontWeight={500} textAlign="left">
              {insurance.AccountOwner}
            </Text>
          </td>

          <td>
            <Text fontWeight={500} textAlign="left">
              {insurance.HealthInsuredMembers && insurance.HealthInsuredMembers.length > 0
                ? insurance.HealthInsuredMembers.join(', ')
                : ''}
            </Text>
          </td>

          <td>
            <Text variant="tabular" fontWeight={500} textAlign="right">
              {insurance.HealthFamilyDeductible !== null
                ? formatCurrency(insurance.HealthFamilyDeductible)
                : ''}
            </Text>
          </td>

          <td>
            <Text variant="tabular" fontWeight={500} textAlign="right">
              {insurance.HealthOutOfPocketLimit !== null
                ? formatCurrency(insurance.HealthOutOfPocketLimit)
                : ''}
            </Text>
          </td>

          <td>
            <Text variant="tabular" fontWeight={500} textAlign="right">
              {insurance.Premium !== null ? formatCurrency(insurance.Premium) : ''}
            </Text>
          </td>

          {!isPrint && (
            <TableActions
              insuranceName={insurance.Description}
              onEdit={() => setInsuranceToUpsert(insurance)}
              onDelete={() => setInsuranceToDelete({ id: insurance.AccountId })}
            />
          )}
        </tr>
      ))}
    </InsuranceTable>
  );
};
